import React, { useContext } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import './Settings.css'
import { getSettings } from './SettingsMenu'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../../../../global'

type Params = {
  accountId: string
}

type Props = {
  onNavigate: () => void
}

export default function SettingsMenu(props: Props) {
  const history = useHistory()
  const { accountId } = useParams() as Params
  const location = useLocation()
  const { t } = useTranslation(['settings_details', 'settings_certificates'])
  const { onNavigate } = props
  const { state } = useContext(AppContext)
  const isPapertrailEmployee = state.auth.isPapertrailEmployee
  const settings = getSettings(accountId, t, isPapertrailEmployee)

  function onNavigateClick(url: string) {
    onNavigate()
    history.push(url)
  }

  function getStyle(url: string) {
    return location.pathname === url
      ? 'selected-menu-item-text'
      : 'unselected-menu-item-text'
  }

  function getIndicator(url: string) {
    return location.pathname === url
      ? 'selected-menu-indicator'
      : 'deselected-menu-indicator'
  }

  return (
    <div id="settings-menu-compact-container">
      <div id="settings-menu-compact">
        {settings.map(setting => (
          <div className="settings-menu-item"
            key={setting.key}
            data-cy={setting.key}
            onClick={() => onNavigateClick(setting.url)}>
            <div className={getIndicator(setting.url)} />
            <div className="settings-menu-item-inner">
              <span className={getStyle(setting.url)}>
                {setting.text}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
